import { createTranslationFile, createLanguage } from "@vocab/core/runtime";
const translations = createTranslationFile({
  en: createLanguage({
    "copyright seek": "© {brand}. All rights reserved",
    "copyright jobsdb": "Copyright © 1998-{year}, {brand}",
    "copyright jobstreet": "Copyright © {year}, {brand}"
  }),
  th: createLanguage({
    "copyright seek": "© {brand}. All rights reserved",
    "copyright jobsdb": "สงวนลิขสิทธิ์ 1998-{year} โดย บริษัท จัดหางาน จ๊อบส์ ดีบี (ประเทศไทย) จำกัด",
    "copyright jobstreet": "Copyright © {year}, {brand}"
  }),
  id: createLanguage({
    "copyright seek": "© {brand}. All rights reserved",
    "copyright jobsdb": "Copyright © 1998-{year}, {brand}",
    "copyright jobstreet": "Hak cipta © {year} {brand}"
  }),
  zh: createLanguage({
    "copyright seek": "© {brand}。保留所有權利",
    "copyright jobsdb": "版權所有 © 1998-{year}，{brand}",
    "copyright jobstreet": "版權所有 © {year}，{brand}"
  }),
  "en-AU": createLanguage({
    "copyright seek": "© {brand}. All rights reserved",
    "copyright jobsdb": "Copyright © 1998-{year}, {brand}",
    "copyright jobstreet": "Copyright © {year}, {brand}"
  }),
  "en-HK": createLanguage({
    "copyright seek": "© {brand}. All rights reserved",
    "copyright jobsdb": "Copyright © 1998-{year}, {brand}",
    "copyright jobstreet": "Copyright © {year}, {brand}"
  }),
  "en-ID": createLanguage({
    "copyright seek": "© {brand}. All rights reserved",
    "copyright jobsdb": "Copyright © 1998-{year}, {brand}",
    "copyright jobstreet": "Copyright © {year}, {brand}"
  }),
  "en-MY": createLanguage({
    "copyright seek": "© {brand}. All rights reserved",
    "copyright jobsdb": "Copyright © 1998-{year}, {brand}",
    "copyright jobstreet": "Copyright © {year}, {brand}"
  }),
  "en-NZ": createLanguage({
    "copyright seek": "© {brand}. All rights reserved",
    "copyright jobsdb": "Copyright © 1998-{year}, {brand}",
    "copyright jobstreet": "Copyright © {year}, {brand}"
  }),
  "en-PH": createLanguage({
    "copyright seek": "© {brand}. All rights reserved",
    "copyright jobsdb": "Copyright © 1998-{year}, {brand}",
    "copyright jobstreet": "Copyright © {year}, {brand}"
  }),
  "en-SG": createLanguage({
    "copyright seek": "© {brand}. All rights reserved",
    "copyright jobsdb": "Copyright © 1998-{year}, {brand}",
    "copyright jobstreet": "Copyright © {year}, {brand}"
  }),
  "en-TH": createLanguage({
    "copyright seek": "© {brand}. All rights reserved",
    "copyright jobsdb": "Copyright © 1998-{year}, {brand}",
    "copyright jobstreet": "Copyright © {year}, {brand}"
  }),
  "th-TH": createLanguage({
    "copyright seek": "© {brand}. All rights reserved",
    "copyright jobsdb": "สงวนลิขสิทธิ์ 1998-{year} โดย บริษัท จัดหางาน จ๊อบส์ ดีบี (ประเทศไทย) จำกัด",
    "copyright jobstreet": "Copyright © {year}, {brand}"
  }),
  "id-ID": createLanguage({
    "copyright seek": "© {brand}. All rights reserved",
    "copyright jobsdb": "Copyright © 1998-{year}, {brand}",
    "copyright jobstreet": "Hak cipta © {year} {brand}"
  }),
  "zh-HK": createLanguage({
    "copyright seek": "© {brand}。保留所有權利",
    "copyright jobsdb": "版權所有 © 1998-{year}，{brand}",
    "copyright jobstreet": "版權所有 © {year}，{brand}"
  }),
  "en-PSEUDO": createLanguage({
    "copyright seek": "[© {brand}. Ậƚƚ řììììģḩṯš řẽẽẽẽšẽẽẽẽřṽẽẽẽẽƌ]",
    "copyright jobsdb": "[Çööööƥýýýýřììììģḩṯ © 1998-{year}, {brand}]",
    "copyright jobstreet": "[Çöööƥýýýřìììģḩṯ © {year}, {brand}]"
  })
});
export {
  translations
};
